import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { getFrameAfterRotate } from '@src/slide/infrastructure/module/independent/graphic';
import { IFrame } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';

interface ISelectRect {
    top: number;
    left: number;
    width: number;
    height: number;
}

function isElementInSelectRect(elementFrame, rectToSlide: ISelectRect) {
    return elementFrame.left >= rectToSlide.left
        && elementFrame.top >= rectToSlide.top
        && (elementFrame.left + elementFrame.width) <= (rectToSlide.left + rectToSlide.width)
        && (elementFrame.top + elementFrame.height) <= (rectToSlide.top + rectToSlide.height);
}

export function setSelectedWithRect(selectionService: ISelectionService, rect, scale, canvasSize, offset) {
    if (!rect) return;
    const { currentSlide } = selectionService;
    selectionService.selectedElements.clear();
    const rectToSlide: ISelectRect = {
        left: (rect.left - offset.x - canvasSize.left) / scale,
        top: (rect.top - offset.y - canvasSize.top) / scale,
        width: rect.width / scale,
        height: rect.height / scale,
    };

    const selectedModels: any[] = [];
    (currentSlide?.children || []).forEach((elementModel) => {
        if (elementModel.selectable) {
            let elementFrame: any = elementModel.getFrame?.().getFrameInfo();
            if (elementFrame.rotate) {
                elementFrame = getFrameAfterRotate(elementFrame, elementFrame.rotate);
            }
            if (isElementInSelectRect(elementFrame, rectToSlide)) {
                selectedModels.push(elementModel);
            }
        }
    });

    selectionService.selectedElements.add(...selectedModels);
}

export const testObj = {
    isElementInSelectRect,
};
